export default __webpack_public_path__ + "static/media/PlocastaKomora.76590f5e.png";